// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"498":"reservations","699":"region-detail","953":"villa-detail"}[chunkId] || chunkId) + "." + {"453":"7a7ed6ed","498":"5bf35769","699":"e351a40f","953":"d5771737"}[chunkId] + ".chunk.js";
};